/**
 * Copyright © 2026 Adnuntius AS.
 */
export interface CreativeDimensionOption {
  label: string;
  width: number;
  height: number;
}

export interface CreativeEditViewState {
  layouts: any[];
  showGeneralVariables: boolean;
  hasAxProductDimensions: boolean;
  allowedDimensions: CreativeDimensionOption[];
  selectedDimension: CreativeDimensionOption | undefined;
  optionalTargetTypes: string[];
  isLockedDown: boolean;
  isCreativeContentLocked: boolean;
  allComponents: any[];
  assetMatches: Record<string, any>;
  primaryHtmlAsset: any;
  isFullPage: boolean;
  allowPreviews: boolean;
  allResolved: boolean;
  simplifiedCreativeFormatFee: any;
  selectedRetailProduct: any;
  isPureRetailCreative: boolean;
  hasLibraryCreative: boolean;
  advertiserMismatch: any;
  postOrphan: boolean;
  blockSubmit: boolean;
  externalDemandSources: any[] | null;
  chartCurrency: any;
  previewData: any;
  previewFailure: string | null;
  isDelinking: boolean;
}

export function createCreativeEditViewState(): CreativeEditViewState {
  return {
    layouts: [],
    showGeneralVariables: false,
    hasAxProductDimensions: false,
    allowedDimensions: [],
    selectedDimension: undefined,
    optionalTargetTypes: [],
    isLockedDown: false,
    isCreativeContentLocked: false,
    allComponents: [],
    assetMatches: {},
    primaryHtmlAsset: undefined,
    isFullPage: false,
    allowPreviews: false,
    allResolved: false,
    simplifiedCreativeFormatFee: undefined,
    selectedRetailProduct: null,
    isPureRetailCreative: false,
    hasLibraryCreative: false,
    advertiserMismatch: null,
    postOrphan: false,
    blockSubmit: false,
    externalDemandSources: null,
    chartCurrency: undefined,
    previewData: undefined,
    previewFailure: null,
    isDelinking: false
  };
}
